import builder from '../builder';
import LocationPin from '../../streamline-icons/bold/location-pin.svg';

export default builder('LocationPinBold', LocationPin);
